// extracted by mini-css-extract-plugin
var _1 = "RequestBoardColumnSkeleton-moduleRequestBoardColumnSkeleton__gDBVp";
var _2 = "RequestBoardColumnSkeleton-modulemeta__eM1I5 Skeleton-moduleSkeleton__Mlrfv";
var _3 = "RequestBoardColumnSkeleton-moduletitle__WVgKM Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "RequestBoardColumnSkeleton", _2 as "meta", _3 as "title" }
